export const normalizeJpeg = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      resolve(file);
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      img.src = reader.result as string;
    };

    reader.onerror = reject;

    img.onload = () => {
      const MAX_SIZE = 2500;

      const scale = Math.min(
        1,
        MAX_SIZE / img.naturalWidth,
        MAX_SIZE / img.naturalHeight
      );

      const width = Math.round(img.naturalWidth * scale);
      const height = Math.round(img.naturalHeight * scale);

      const canvas = document.createElement('canvas');

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');

      if (!ctx) {
        resolve(file);
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file);
            return;
          }

          const normalizedFile = new File(
            [blob],
            file.name,
            {
              type: 'image/jpeg',
              lastModified: Date.now(),
            }
          );

           console.log('NORMALIZE SUCCESS', {
            originalSize: file.size,
            normalizedSize: normalizedFile.size,
            originalWidth: img.naturalWidth,
            originalHeight: img.naturalHeight,
            width,
            height,
          });

          resolve(normalizedFile);
        },
        'image/jpeg',
        0.8
      );
    };

    img.onerror = reject;

    reader.readAsDataURL(file);
  });
};
